import { makeStyles, Skeleton, SkeletonItem, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  isLoading?: boolean;
}

export default function Suspense(props: Props) {
	const classes = useStyles();

	return (
		<>
			{props.isLoading && (
				<Skeleton className={classes.root}>
					<SkeletonItem className={classes.skeletonItem} />
				</Skeleton>
			)}
			{!props?.isLoading && props?.children}
		</>
	);
}

export const useStyles = makeStyles({
	root: {
		padding: '0px',
	},
	skeletonItem: {
		height: '32px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});